var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcOutlineAnalytics(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Loan-Details-and-Property",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Loan-Creation-360",
    transform: "translate(-119.000000, -442.000000)",
    fill: "#32325D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(119.000000, 442.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6666667,0 L1.33333333,0 C0.6,0 0,0.6 0,1.33333333 L0,10.6666667 C0,11.4 0.6,12 1.33333333,12 L10.6666667,12 C11.4,12 12,11.4 12,10.6666667 L12,1.33333333 C12,0.6 11.4,0 10.6666667,0 Z M10.6666667,10.6666667 L1.33333333,10.6666667 L1.33333333,1.33333333 L10.6666667,1.33333333 L10.6666667,10.6666667 Z",
    id: "Icon-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66666667,6 L4,6 L4,9.33333333 L2.66666667,9.33333333 L2.66666667,6 Z M8,2.66666667 L9.33333333,2.66666667 L9.33333333,9.33333333 L8,9.33333333 L8,2.66666667 Z M5.33333333,7.33333333 L6.66666667,7.33333333 L6.66666667,9.33333333 L5.33333333,9.33333333 L5.33333333,7.33333333 Z M5.33333333,4.66666667 L6.66666667,4.66666667 L6.66666667,6 L5.33333333,6 L5.33333333,4.66666667 Z",
    id: "Icon-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineAnalytics);
export default __webpack_public_path__ + "static/media/ic-outline-analytics.34e6e529a834bc626997f5ab33d0c6b3.svg";
export { ForwardRef as ReactComponent };